import theme from 'styles/theme'

export const profileFieldSx = (locked: boolean, labelBg: string) => ({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: 0,
    backgroundColor: locked ? '#f9fafb' : '#fff',
    fontSize: '14px',
    color: locked ? theme.r4r.grey : theme.r4r.ink,
    '& fieldset': { borderColor: theme.r4r.greyLight },
    '&:hover fieldset': { borderColor: theme.r4r.greyLight },
    '&.Mui-focused fieldset': { borderColor: theme.r4r.navy, borderWidth: '1px' },
    '&.Mui-disabled': {
      backgroundColor: '#fff',
      '& fieldset': { borderColor: theme.r4r.greyLight }
    },
    '&.Mui-disabled .MuiOutlinedInput-input': {
      WebkitTextFillColor: theme.r4r.ink
    }
  },
  '& .MuiOutlinedInput-input': {
    py: '17px',
    px: '17px',
    height: '17px',
    boxSizing: 'content-box' as const,
    '&::placeholder': {
      color: '#B0B3BA',
      opacity: 1
    }
  },
  '& .MuiInputLabel-root': {
    fontSize: '11px',
    fontWeight: 600,
    color: `${theme.r4r.grey} !important`,
    backgroundColor: labelBg,
    px: '6px',
    transform: 'translate(14px, -8px) scale(1)'
  },
  '& .MuiInputLabel-root.MuiInputLabel-shrink': {
    transform: 'translate(14px, -8px) scale(1)'
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: `${theme.r4r.grey} !important`
  }
})

export const saveButtonSx = {
  backgroundColor: theme.r4r.navy,
  color: '#fff',
  borderRadius: 0,
  boxShadow: 'none',
  fontSize: '13px',
  fontWeight: 700,
  lineHeight: '13px',
  px: '32px',
  py: '12px',
  ':hover': { backgroundColor: theme.r4r.ink, boxShadow: 'none' },
  '&.Mui-disabled': {
    backgroundColor: theme.r4r.greyLight,
    color: theme.r4r.grey
  }
} as const

export const cancelButtonSx = {
  border: `1px solid ${theme.r4r.greyLight}`,
  borderRadius: 0,
  color: theme.r4r.grey,
  fontSize: '13px',
  fontWeight: 600,
  lineHeight: '13px',
  px: '25px',
  py: '13px',
  ':hover': { backgroundColor: 'transparent', borderColor: theme.r4r.grey }
} as const

export const azureButtonSx = {
  backgroundColor: theme.r4r.azure,
  color: '#fff',
  borderRadius: 0,
  boxShadow: 'none',
  fontSize: '13px',
  fontWeight: 700,
  letterSpacing: '0.5px',
  lineHeight: '13px',
  textTransform: 'uppercase' as const,
  px: '24px',
  py: '14px',
  ':hover': { backgroundColor: '#5A78D4', boxShadow: 'none' },
  '&.Mui-disabled': {
    backgroundColor: theme.r4r.greyLight,
    color: theme.r4r.grey
  }
} as const
